// extracted by mini-css-extract-plugin
export default {"reports-layout__title":"reports-layout_reports-layout__title__5dVV3","reports-layout__menu":"reports-layout_reports-layout__menu__YovAx"};